<template>
	<div id="app">
		<component :is="layout">
			<router-view />
		</component>
	</div>
</template>

<script>
import DefaultLayout from '@/layouts/default'
import NavbarlessLayout from '@/layouts/navbarless'
import CaseLayout from '@/layouts/case'

export default {
	computed: {
		layout() {
			return (this.$route.meta.layout || 'default') + '-layout'
		}
	},
	components: {
		DefaultLayout,
		NavbarlessLayout,
		CaseLayout
	}
}
</script>

<style lang="sass">
@import '@/assets/css'

#app
	+wrapper()
</style>
